import React, { useState, useEffect, useContext } from "react";
import "./RewardsBrands.css";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "../global/EmblaCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import BrandsFeaturesCarousel from "./BrandsFeaturesCarousel";
import { BrandsContext } from "../../context/BrandsContext";

const RewardsBrands = () => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [currentBrand, setCurrentBrand] = useState();
  const { brands, getBrands } = useContext(BrandsContext);

  useEffect(() => {
    if (!brands) {
      getBrands();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = { align: "start", loop: true };
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className="container rewards-brands position-relative">
      <h2 className=" brands-title mb-3">NUESTRAS MARCAS</h2>
      <p className="brands-desc">Conoce las marcas participantes</p>

      <section className="carousel__rewards-brands">
        <div className="rewards-brands__viewport" ref={emblaRef}>
          <div className="rewards-brands__container">
            {brands && brands.map((brand, index) => (
              <div
                key={index}
                className="brand-card rewards-brands__slide d-flex flex-column align-items-center justify-content-center"
              >
                <img
                  alt="brand"
                  src={brand.file?.src || brand.logo}
                  width="auto"
                  style={{ maxHeight: "100px", minWidth: "100px" }}
                />
                <button
                  type="button"
                  className="brand-btn btn mt-2"
                  onClick={() => {
                    brand.index = index;
                    setCurrentBrand(brand);
                    setShowCarousel(true);
                  }}
                >
                  +
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="rewards-brands__controls">
          <div className="rewards-brands__buttons">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      </section>

      {showCarousel && currentBrand && (
        <BrandsFeaturesCarousel
          selectedBrand={currentBrand}
          showCarousel={showCarousel}
          setShowCarousel={setShowCarousel}
          brands={brands}
        />
      )}
    </div>
  );
}

export default RewardsBrands;